const transformQuestionsData = (questions) => {
  return questions.map((question) => {
    return {
      ...question,
      ...question.options,
      options: undefined,
      correct_option: question.correct_option?.id || question.correct_option,
    }
  })
}

export default transformQuestionsData
